export const DICE_LIMITS = { d20: 8, d6: 15 } as const;
export type DiceType = keyof typeof DICE_LIMITS;
export type DiceRoll = {
  id: string;
  diceType: DiceType;
  count: number;
  rolls: number[];
  total: number;
  createdAt: string;
};

function secureInt(maxExclusive: number): number {
  const range = 0x1_0000_0000;
  const limit = range - (range % maxExclusive);
  const value = new Uint32Array(1);
  do crypto.getRandomValues(value);
  while (value[0] >= limit);
  return value[0] % maxExclusive;
}

export function rollDice(diceType: DiceType, count: number): DiceRoll {
  if (!Number.isInteger(count) || count < 1 || count > DICE_LIMITS[diceType]) {
    throw new Error(
      `Допустимо от 1 до ${DICE_LIMITS[diceType]} кубиков ${diceType}.`,
    );
  }
  const sides = diceType === "d20" ? 20 : 6;
  const rolls = Array.from({ length: count }, () => secureInt(sides) + 1);
  return {
    id: crypto.randomUUID(),
    diceType,
    count,
    rolls,
    total: rolls.reduce((sum, roll) => sum + roll, 0),
    createdAt: new Date().toISOString(),
  };
}
